import { getCurrentInstance } from "vue";

export function findRootContext() {
  let ctx = getCurrentInstance();
  while (ctx.parent) {
    ctx = ctx.parent;
  }
  return ctx;
}

/**
 * Returns the nearest instance, starting from the current one, that `markScope` marked with
 * `scope`. Falls back to the root instance when no ancestor carries the mark.
 *
 * @param {symbol} scope
 */
export function findScopeContext(scope) {
  let ctx = getCurrentInstance();
  while (ctx.__scope !== scope && ctx.parent) {
    ctx = ctx.parent;
  }
  return ctx;
}

/**
 * Marks the current instance as the boundary for `scope`, so `findScopeContext(scope)` called from
 * it or any descendant stops here.
 *
 * @param {symbol} scope
 */
export function markScope(scope) {
  getCurrentInstance().__scope = scope;
}
